import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const atiraLinkState = (state: RootState) => state.atiraLink;

const selectUserAtiraLinks = createSelector(
  atiraLinkState,
  (state) => state.atiraLinks || [],
);

const selectUserAtiraLinkLoading = createSelector(
  atiraLinkState,
  (state) => state.atiraLinkLoading,
);

const selectSelectedAtiraLinkStats = createSelector(
  atiraLinkState,
  (state) => state.selectedAtiraLinkStats,
);

const selectThemes = createSelector(
  atiraLinkState,
  (state) => state.themes || [],
);

const selectThemesPage = createSelector(
  atiraLinkState,
  (state) => state.themesPage || 0,
);

const selectThemesPageHasNext = createSelector(
  atiraLinkState,
  (state) => state.themesPageHasNext,
);

const selectThemesLoading = createSelector(
  atiraLinkState,
  (state) => state.themesLoading,
);

const selectSelectedAtiraLink = createSelector(
  atiraLinkState,
  (state) => state.selectedAtiraLink,
);

const selectThemeDataByName = createSelector(
  atiraLinkState,
  (_, name: string) => name,
  (state, name) => state.themesDataByName?.[name] || {},
);

const selectSocialsClickCount = createSelector(
  atiraLinkState,
  (state) => state.socialsClickCount,
);

export const atiraLinkSliceSelectors = {
  selectUserAtiraLinks,
  selectUserAtiraLinkLoading,
  selectSelectedAtiraLinkStats,
  selectThemes,
  selectThemesPage,
  selectThemesPageHasNext,
  selectThemesLoading,
  selectSelectedAtiraLink,
  selectThemeDataByName,
  selectSocialsClickCount,
};
